// Fenny i18n grund. Init alltid på "sv" så SSR-HTML och första klient-render
// matchar (förhindrar React hydration-error #418). EN-bundle lazy-loadas
// första gången användaren byter eller landar på /en/*.
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import sv from "./locales/sv.json";

export const SUPPORTED_LANGS = ["sv", "en"] as const;
export type AppLang = (typeof SUPPORTED_LANGS)[number];

export const STORAGE_KEY = "fenny.lang";

export function normalizeLang(input: string | null | undefined): AppLang {
  if (!input) return "sv";
  const lower = input.toLowerCase();
  if (lower.startsWith("en")) return "en";
  return "sv";
}

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources: { sv: { translation: sv } },
    lng: "sv",
    fallbackLng: "sv",
    supportedLngs: SUPPORTED_LANGS as unknown as string[],
    load: "languageOnly",
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });
}

const loadedLangs = new Set<AppLang>(["sv"]);
const inFlight = new Map<AppLang, Promise<void>>();

export async function loadLanguage(lang: AppLang): Promise<void> {
  if (loadedLangs.has(lang)) return;
  const existing = inFlight.get(lang);
  if (existing) return existing;

  const promise = (async () => {
    if (lang === "en") {
      const mod = await import("./locales/en.json");
      i18n.addResourceBundle("en", "translation", mod.default ?? mod, true, true);
    }
    loadedLangs.add(lang);
  })();

  inFlight.set(lang, promise);
  try {
    await promise;
  } finally {
    inFlight.delete(lang);
  }
}

export default i18n;
